import { BiSolidCameraPlus, BiBuildings, BiLogoMicrosoft, BiSolidBaguette, BiSolidBuildings } from "react-icons/bi";
import {
    BsBoxFill, BsFillPersonPlusFill, BsCameraVideoFill,
    BsCameraFill, BsFillKeyFill, BsFillFileEarmarkZipFill, BsFillImageFill,
    BsQuestionCircleFill, BsBoxArrowRight, BsFillPostcardFill,
    BsClipboard2PlusFill, BsFillPeopleFill, BsFillRocketTakeoffFill,
    BsPersonCircle, BsClockFill, BsWebcam, BsJournals, BsDatabaseFill, BsCpuFill
} from "react-icons/bs";
import { TbBrandWindowsFilled } from "react-icons/tb";
import { FaMicrosoft } from "react-icons/fa6";

// import Profile from "../pages/auth/Profile"
import Login from "../pages/auth/Login"
import Dashboard from "../pages/dashboard/Dashboard";
import CameraDashboard from "../pages/camera/Dashboard";
import StorageDashboard from "../pages/storage/Dashboard";
import SystemInfoDashboard from "../pages/system-info/Dashboard";
import Role from "../pages/permissions/Role"
import Profile from "../pages/auth/Profile";
import ResetPassword from '../pages/auth/ResetPassword';
import ForgotPassword from '../pages/auth/ForgotPassword';

import UserManagementView from '../pages/users/View';
import ProjectView from '../pages/project/View';




export const anonyMenus = [
    {
        to: "/",
        component: <Login />,
    },
    {
        to: "/login/",
        component: <Login />,
    },
    {
        to: "/forgot-password/",
        component: <ForgotPassword />,
    },
    {
        to: "/reset-password/",
        component: <ResetPassword />,
    },
]

export const menus = [

    {
        to: "/login/",
        component: <Login />,
        hide: true,
        hideSideBar: true,
        hideHeader: true
    },
    {
        icon: <BiLogoMicrosoft size={20} />,
        label: "Dashboard",
        to: "/",
        component: <Dashboard />,
    },
    {
        icon: <BiLogoMicrosoft size={20} />,
        label: "Dashboard",
        to: "/dashbord/",
        component: <Dashboard />,
        permission: "*"
    },

    // {
    //     icon: <BsPersonCircle size={18} />,
    //     label: "My Profile",
    //     to: "/profile/",
    //     component: <Profile />,
    //     permission: "*",
    // },

    {
        icon: <BsJournals size={20} />,
        label: "Camera <br/> Report",
        to: "/camera-report/",
        component: <CameraDashboard />,
        permission: "*",
    },
    {
        icon: <BsCpuFill size={20} />,
        label: "System <br/> Report",
        to: "/system-report/",
        component: <SystemInfoDashboard />,
        permission: "*",
    },
    {
        icon: <BsDatabaseFill size={20} />,
        label: "Backup <br/> Report",
        to: "/backup-report/",
        component: <StorageDashboard />,
        permission: "*",
    },

    {
        icon: <BsFillRocketTakeoffFill size={20} />,
        label: "Project <br/> Management",
        to: "/project/",
        component: <ProjectView />,
        permission: "view_project",
    },
    // {
    //     icon: <BsFillPersonPlusFill size={20} />,
    //     label: "User <br/> Management",
    //     to: "/user-management/",
    //     component: <UserManagementView />,
    //     permission: "view_user",
    // },

    {
        icon: <BsFillPeopleFill size={20} />,
        label: "Permissions",
        to: "/role/",
        component: <Role />,
        permission: "view_permission",
    },

    {
        icon: <BsQuestionCircleFill size={19} />,
        label: "Helps",
        to: "/help/",
        component: <></>,
        permission: "*",
    }
]